import { eu_taxonomy_compliance_enum, eu_taxonomy_datasource_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

/**
 * Translates the EU Taxonomy compliance tier. The `NON_COMPLIANT` label depends on the org's
 * EU Taxonomy data source: DEFAULT_INDEX splits top-15% / top-30% / bottom-70%, whereas
 * DREES_UND_SOMMER only splits top-15% vs. the bottom-85% — so "Untere 70%" vs "Untere 85%".
 * COMPLIANT stays "Top 15%" for both and MEETS_DNSH_CRITERIA never occurs under DREES_UND_SOMMER.
 *
 * This file is intentionally hand-maintained (NOT produced by generateEnumTranslations.ts, which
 * cannot express the datasource dependency and would overwrite it). It lives outside `src/enums/`
 * so the generator's `rm src/enums/*` never touches it. The nested datasource switch is exhaustive
 * — adding a new eu_taxonomy_datasource_enum member breaks the build here.
 */
export const translateEuTaxonomyComplianceEnum = (
  enumValue: eu_taxonomy_compliance_enum,
  datasource: eu_taxonomy_datasource_enum,
) => {
  switch (enumValue) {
    case eu_taxonomy_compliance_enum.COMPLIANT:
      return <Trans i18nKey="Enum_EuTaxonomyComplianceEnum-COMPLIANT" />;
    case eu_taxonomy_compliance_enum.MEETS_DNSH_CRITERIA:
      return <Trans i18nKey="Enum_EuTaxonomyComplianceEnum-MEETS_DNSH_CRITERIA" />;
    case eu_taxonomy_compliance_enum.NON_COMPLIANT:
      switch (datasource) {
        case eu_taxonomy_datasource_enum.DEFAULT_INDEX:
          return <Trans i18nKey="Enum_EuTaxonomyComplianceEnum-NON_COMPLIANT" />;
        case eu_taxonomy_datasource_enum.DREES_UND_SOMMER:
          return <Trans i18nKey="Enum_EuTaxonomyComplianceEnum-NON_COMPLIANT-DREES_UND_SOMMER" />;
        default: {
          const _exhaustive: never = datasource;
          return _exhaustive;
        }
      }
    case eu_taxonomy_compliance_enum.UNKNOWN:
      return <Trans i18nKey="Enum_EuTaxonomyComplianceEnum-UNKNOWN" />;
  }
};

export const translateEuTaxonomyComplianceEnum_dynamic = (
  enumValue: eu_taxonomy_compliance_enum,
  datasource: eu_taxonomy_datasource_enum,
) => {
  const t = getI18n().t;
  switch (enumValue) {
    case eu_taxonomy_compliance_enum.COMPLIANT:
      return t('Enum_EuTaxonomyComplianceEnum-COMPLIANT');
    case eu_taxonomy_compliance_enum.MEETS_DNSH_CRITERIA:
      return t('Enum_EuTaxonomyComplianceEnum-MEETS_DNSH_CRITERIA');
    case eu_taxonomy_compliance_enum.NON_COMPLIANT:
      switch (datasource) {
        case eu_taxonomy_datasource_enum.DEFAULT_INDEX:
          return t('Enum_EuTaxonomyComplianceEnum-NON_COMPLIANT');
        case eu_taxonomy_datasource_enum.DREES_UND_SOMMER:
          return t('Enum_EuTaxonomyComplianceEnum-NON_COMPLIANT-DREES_UND_SOMMER');
        default: {
          const _exhaustive: never = datasource;
          return _exhaustive;
        }
      }
    case eu_taxonomy_compliance_enum.UNKNOWN:
      return t('Enum_EuTaxonomyComplianceEnum-UNKNOWN');
  }
};
